import React from 'react'
import styled from 'styled-components'
import { fonts } from '../../style/theme'

const Root = styled.span`
  color: white;
  font-family: ${fonts.secondary};
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  ${({ $customStyle }) => $customStyle};
`

/**
 * Call-to-action text component
 *
 * @param {string} text - The text to display
 * @param {object} customStyle - Custom styled-components CSS (e.g., customCtaCard, customCtaWhite)
 * @param {string} dataTestId - Test ID for the element
 * @param {boolean} isGerman - Optional flag for German-specific font sizing in styles that reference `$isGerman` (e.g., customCtaCard); when omitted, default sizing is used
 */
const Cta = ({ text, customStyle, dataTestId, isGerman }) => {
  return (
    <Root $customStyle={customStyle} data-testid={dataTestId} $isGerman={isGerman}>
      {text}
    </Root>
  )
}

export default Cta
